import { escapeHtml } from './format'

/**
 * Semnele de langa stapanul unui aparat, in celulele de lista (HTML scris de
 * coloane) - aceleasi clase ca pe fisa (`DeviceSummary`), ca sa arate la fel:
 *
 *   - insigna "Auto": stapanul a fost pus AUTOMAT din Active Directory si e
 *     inca el. Fara insigna = pus de mana. Textul tooltip-ului vine de la
 *     server (`OwnerMarks::autoTitle`), ca fisa si listele sa spuna acelasi lucru;
 *   - sugestia "Suggested: Ion Popescu" din logari, cu [Assign] / [Dismiss]
 *     numai pentru cine are dreptul de alocare (`canAccept`).
 *
 * Butoanele se prind prin delegare (`onSuggestionClick`), ca Remove din
 * aceeasi lista: HTML-ul celulei n-are cum sa aiba onClick-ul lui.
 */

export const AUTO_CLASS = 'od-owner-auto'
export const SUGGEST_ACCEPT_CLASS = 'od-suggest-accept'
export const SUGGEST_DISMISS_CLASS = 'od-suggest-dismiss'

/** Insigna "Auto", sau '' cand stapanul e pus de mana. */
export function autoBadgeHtml(title: unknown): string {
  if (typeof title !== 'string' || title === '') return ''
  return ` <span class="${AUTO_CLASS}" title="${escapeHtml(title)}">Auto</span>`
}

export interface RowSuggestion {
  name: string
  days: number
  window: number
  text: string
  canAccept: boolean
}

/** "Suggested: X" sub numele aparatului, cu butoanele lui; '' fara sugestie. */
export function suggestionHtml(deviceId: number, suggestion: unknown): string {
  if (!suggestion || typeof suggestion !== 'object') return ''
  const s = suggestion as RowSuggestion
  const buttons = s.canAccept
    ? ` <button type="button" class="btn btn-xs btn-theme ${SUGGEST_ACCEPT_CLASS}" data-id="${deviceId}">Assign</button>` +
      ` <button type="button" class="btn btn-xs btn-default ${SUGGEST_DISMISS_CLASS}" data-id="${deviceId}">Dismiss</button>`
    : ''
  return (
    `<div class="od-owner-suggest" title="${escapeHtml(s.text)}">` +
    `<i class="fas fa-lightbulb" aria-hidden="true"></i> Suggested: <strong>${escapeHtml(s.name)}</strong>` +
    ` <span class="od-owner-suggest-days">${Number(s.days)} of ${Number(s.window)} days</span>${buttons}</div>`
  )
}

/** Ce buton de sugestie a fost apasat, daca a fost unul. */
export function suggestionAction(target: HTMLElement): { action: 'accept' | 'dismiss'; deviceId: number; button: HTMLElement } | null {
  const accept = target.closest(`.${SUGGEST_ACCEPT_CLASS}`)
  const dismiss = target.closest(`.${SUGGEST_DISMISS_CLASS}`)
  const button = (accept ?? dismiss) as HTMLElement | null
  if (!button) return null
  const deviceId = Number(button.dataset.id ?? 0)
  if (deviceId < 1) return null
  return { action: accept ? 'accept' : 'dismiss', deviceId, button }
}
